module.exports = __webpack_public_path__ + "static/media/money_bonus_1.5764cddd.svg";